module.exports = {"name":"Vyber sutaze","icon":"<i class='material-icons'>filter_list</i>","widget":[{"type":"competition-selector","schemas":{"competitions":"urn:mbry:schema:1:competitions:v1","competitionParts":"urn:mbry:schema:1:competitionParts:v1","competitionGroups":"urn:mbry:schema:1:competitionGroups:v1"},"initData":{}}]}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/selector/selector.json
// module id = 392
// module chunks = 0